new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        banners: {
            bandCommuniqueDropdown: false,
        },
        mobile: (window.innerWidth > 991) ? false : true,
        tabletPortrait: (window.innerWidth > 767) ? true : false
    },
    created() {
        window.addEventListener("resize", this.screenHandler);
    },
    mounted() {
        this.secondBlock = true;
    },
    destroyed() {
        window.removeEventListener("resize", this.screenHandler);
    },
    methods: {
        screenHandler() {
            this.mobile = (window.innerWidth > 991) ? false : true;
            this.tabletPortrait = (window.innerWidth > 767) ? true : false;
        }
    }
})

//sliders
$(document).ready(function () {
    
    var bannerHomeFull = $('.banner-home');
    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    // banner com vídeo: liga/desliga o som do vídeo da plataforma
    $(document).on('click', '.js-video-banner-sound', function () {
        var video = $(this).siblings('video').get(0);
        if (!video) return;
        video.muted = !video.muted;
        if (!video.muted) video.play();
        $(this).toggleClass('is-unmuted', !video.muted);
        $(this).attr('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
    });

    // banner com vídeo: garante o loop do vídeo da plataforma caso o navegador ignore o atributo loop
    // ('ended' não borbulha, por isso o listener em captura)
    document.addEventListener('ended', function (e) {
        if (!e.target.closest || !e.target.closest('.video-banner__video')) return;
        e.target.currentTime = 0;
        e.target.play();
    }, true);

    waitForElementToExist('.faixa-comunicado-content').then(element => {
        $('.faixa-comunicado-content').slick({
            arrows: false,
            infinite: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            speed: 1000,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 991,
                settings: 'unslick'
              }
            ]
          });
    });

    waitForElementToExist('#carousel-comunicado').then(element => {
        $('#carousel-comunicado').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            delay: 2000,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#widget-category').then(element => {
        $('#widget-category').slick({
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 9,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list1').then(element => {
        $('#product_list1').slick({
            arrows: false,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#product_list1').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#product_list2').then(element => {
        $('#product_list2').slick({
            arrows: false,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#product_list3').then(element => {
        $('#product_list3').slick({
            arrows: false,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#product_list4').then(element => {
        $('#product_list4').slick({
            arrows: false,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#product_list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.widget-shes-like__photos').then(element => {
        $('.widget-shes-like__photos').slick({
            arrows: false,
            dots: false,
            infinite: false,
            autoplay: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 5,
                    }
                }
            ]
        });
    });
})